import * as types from './mutation-types'

export const addBusiness = ({ commit, dispatch, state }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.post('/api/businessProfile', data).then((response) => {
            commit(types.SET_BUSINESS, response.data.business)
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}
export const updateBusiness = ({ commit, dispatch, state }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.put(`/api/businessProfile/${data.id}`, data).then((response) => {
            commit(types.SET_BUSINESS, response.data.business)
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const fetchBusinessByUser = ({ commit, dispatch, state }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.post('/api/businessProfile/fetchBusinessByUser', data).then((response) => {
            if (response.data.result === true){
                commit(types.SET_BUSINESS_PERMISSION, response.data.userId)
                commit(types.SET_BUSINESS, response.data.business)
            }
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}
export const BusinessPermission = ({ commit, dispatch, state }, data) => {
    return new Promise((resolve, reject) => {
        commit(types.CHECK_BUSINESS_PERMISSION, data)
    })
}
export const falseBusinessPermission = ({ commit, dispatch, state }, data) => {
    return new Promise((resolve, reject) => {
        commit(types.FALSE_BUSINESS_PERMISSION, false)
    })
}
export const unsetBusiness = ({ commit, dispatch, state }, data) => {
    return new Promise((resolve, reject) => {
        commit(types.SET_BUSINESS, [])
    })
}

